import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const PLATFORM_TONES = [
  { id: "minimal", label: "Minimal" },
  { id: "luxury", label: "Luxury" },
  { id: "playful", label: "Playful" },
  { id: "streetwear", label: "Streetwear" },
  { id: "vintage", label: "Vintage" },
  { id: "professional", label: "Professional" },
];
